import { render, staticRenderFns } from "./estimator.vue?vue&type=template&id=154bb554&scoped=true"
import script from "./estimator.vue?vue&type=script&lang=js"
export * from "./estimator.vue?vue&type=script&lang=js"
import style0 from "./estimator.vue?vue&type=style&index=0&id=154bb554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154bb554",
  null
  
)

export default component.exports